import queryString from "query-string";

import { useIsClientSide } from "./isClient.hook";

const useSharedWishListId = () => {
    const isClient = useIsClientSide();

    if (!isClient) {
        return "";
    }

    const { id } = queryString.parse(location.search);
    return id ? `?id=${id}` : "";
};

export { useSharedWishListId };
